import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import { useLocal } from "hooks";
import { Button, FormControl } from "_imports/mui";
import { useGenerateUserIdMutation } from "store/api";
import Header from "Header";

import { FROM_CREATE, FROM_SIGN_IN, Key, Paths } from "../constants";

import "App.css";
import "./CreateAccount.css";

const CreateAccount = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { state } = useLocation();

  const userLocal = useLocal(Key.USER_ID);

  const [generateUserId] = useGenerateUserIdMutation();

  const onSubmit = async () => {
    await generateUserId()
      .unwrap()
      .then((userId) => {
        userLocal.setItem(userId);
        enqueueSnackbar(
          "ID de usuario generado con éxito. Por favor, guárdelo de forma segura.",
          {
            variant: "success",
          }
        );
        navigate(Paths.SUBMIT_ANSWERS, {
          replace: true,
          state: { from: FROM_CREATE },
        });
      })
      .catch((err) => {
        let message: string;
        if (err.status === "FETCH_ERROR") {
          message = "No se puede alcanzar el servidor backend.";
        } else if (err.data?.detail != null) {
          message = err.data.detail;
        } else {
          message = " Error al generar el ID de usuario.";
        }
        enqueueSnackbar(message, {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    const userId = userLocal.getItem();

    if (userId && typeof userId !== "string") {
      userLocal.removeItem();
      return;
    }

    if (userId && state?.from !== FROM_SIGN_IN) {
      navigate(Paths.SIGN_IN, { replace: true });
    }
  }, []);

  return (
    <div className="create-account">
      <Header />
      <div className="center create-account-form">
        <FormControl>
          <Button onClick={onSubmit} variant="contained">
            Crear cuenta
          </Button>

          <Button variant="text">
            <Link to={Paths.SIGN_IN} style={{ textDecoration: "none" }}>
              ¿Ya tienes una cuenta? Inicia sesión.
            </Link>
          </Button>
        </FormControl>
      </div>
    </div>
  );
};

export default CreateAccount;
